import { useState, FC } from "react";
import { GridSelectorModalWindow } from "../../../components/modalWindows/GridSelectorModalWindow";
import { LegalEntityGrid, LegalEntityGridPluginSettings } from ".";
import { v4 as uuidv4 } from 'uuid';
import { IEntitySimpleDTO } from "../../../libs/coreapi-dto/@types/common";
import { useTranslation } from "react-i18next";

const LegalEntitySelectorModal: FC<IGridSelectorModalProps> = (props) => {
    const [entity, setEntity] = useState<IEntitySimpleDTO>(props.selectedEntity ?? {} as IEntitySimpleDTO)
    const gridId = uuidv4();
    const plugin = LegalEntityGridPluginSettings
    const { t } = useTranslation();
    return (
        <GridSelectorModalWindow gridDisplayName={t('directory.legalEntities.title')}
            entityToPressEnter={entity}
            ok={{ onClick: () => props.ok?.(entity) }}
            cancel={{ onClick: () => props.cancel?.() }}>
            {
                plugin
                    ? <LegalEntityGrid gridId={gridId} plugin={plugin}
                        onSelect={(row) => row && setEntity({ idGlobal: row.idGlobal, displayName: row.displayName })}
                        onDoubleClick={(row) => {
                            setEntity({ idGlobal: row.idGlobal, displayName: row.displayName })
                            props.ok?.(entity)
                        }}
                    />
                    : <p>{t('genetal.directoryNotConfigured')}</p>
            }
        </GridSelectorModalWindow>
    )
}

export default LegalEntitySelectorModal